import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import "./buzonDelivery.css";
import ContactForm from "./ContactForm/ContactForm";
import { SpinnerContext } from "./context/spinnerContext";

const baseImages = [
    "/images/DetallePortada.png",
    "/images/PasandoDelivery.png",
    "/images/PasandoCarta2.png",
    "/images/Detalle1.jpg",
    "/images/Detalle2.jpg",
];

const galleryImages = [
    "/images/Detalle5R.png",
    "/images/Detalle6R.png",
    "/images/Detalle7R.png",
    "/images/Detalle8R.png",
    "/images/Detalle9R.png",
    "/images/Detalle10R.png",
    "/images/Detalle1.jpg",
    "/images/Detalle2.jpg",
    "/images/Detalle3.jpg",
    "/images/Detalle4.jpg",
    "/images/PasandoCarta.png",
    "/images/PasandoDelivery.png",
];

const specs = [
    { label: "Material", value: "Hierro de 3,2 mm de espesor" },
    { label: "Construcción", value: "Sólida, resistente y sin partes plásticas" },
    { label: "Terminación", value: "Doble capa de pintura de alta calidad" },
    { label: "Recepción", value: "Paquetes, delivery, cartas y folletos" },
    { label: "Instalación", value: "Rejas, portones, puertas o paredes" },
    { label: "Dimensiones", value: "52 x 32,5 x 9 cm (ancho, alto, profundidad)" },
];

const features = [
    {
        title: "Recibí envíos sin abrir la puerta",
        text: "Permite recibir delivery y paquetes sin exponer el interior de tu casa.",
    },
    {
        title: "También funciona como buzón",
        text: "Incluye entrada para cartas, correspondencia, documentación y folletos de uso diario.",
    },
    {
        title: "Construcción realmente resistente",
        text: "Fabricado en hierro de 3,2 mm de espesor, sin piezas plásticas y pensado para durar.",
    },
    {
        title: "Se adapta a tu acceso",
        text: "Puede instalarse en rejas, portones, puertas, paredes o accesos de viviendas y comercios.",
    },
];

const gallery = Array.from(
    { length: galleryImages.length },
    (_, index) => galleryImages[index % galleryImages.length]
);

type TFooterIcon = "whatsApp" | "mail" | "shipping" | "factory";

const footerItems: Array<{
    icon: TFooterIcon;
    title: string;
    text: string;
    href?: string;
}> = [
        {
            icon: "whatsApp",
            title: "WhatsApp",
            text: "+54 9 1140869822",
            href: "https://wa.me/5491140869822",
        },
        {
            icon: "mail",
            title: "Email",
            text: "info@buzondelivery.com.ar",
            href: "mailto:info@buzondelivery.com.ar",
        },
        {
            icon: "shipping",
            title: "Envíos",
            text: "Envíos a toda la Argentina",
        },
        {
            icon: "factory",
            title: "Fabricación",
            text: "Somos fabricantes",
        },
    ];

function FooterIcon({ icon }: { icon: TFooterIcon }) {
    if (icon === "whatsApp") {
        return (
            <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M12.04 2C6.58 2 2.15 6.35 2.15 11.72c0 1.84.53 3.56 1.45 5.02L2 22l5.42-1.4a10.08 10.08 0 0 0 4.62 1.12c5.46 0 9.89-4.35 9.89-9.72C21.93 6.63 17.5 2 12.04 2Zm0 17.96a8.2 8.2 0 0 1-4.18-1.15l-.3-.18-3.2.83.86-3.05-.2-.32a7.78 7.78 0 0 1-1.2-4.18c0-4.36 3.7-7.9 8.22-7.9 4.54 0 8.23 3.54 8.23 7.9s-3.69 8.05-8.23 8.05Zm4.5-5.88c-.25-.12-1.47-.7-1.7-.78-.23-.08-.4-.12-.57.12-.17.25-.65.78-.8.94-.15.17-.3.19-.55.07-.25-.12-1.05-.38-2-1.2-.74-.65-1.24-1.44-1.38-1.69-.15-.25-.02-.38.1-.5.12-.12.25-.3.37-.44.12-.15.17-.25.25-.42.08-.17.04-.31-.02-.44-.06-.12-.57-1.34-.78-1.84-.2-.48-.41-.42-.57-.43h-.48c-.17 0-.44.06-.67.3-.23.25-.88.84-.88 2.05s.9 2.38 1.03 2.55c.12.17 1.78 2.66 4.31 3.73.6.25 1.07.4 1.44.52.6.19 1.15.16 1.58.1.48-.07 1.47-.58 1.68-1.15.2-.56.2-1.04.14-1.15-.06-.1-.22-.17-.47-.3Z" />
            </svg>
        );
    }

    if (icon === "mail") {
        return (
            <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M4 5h16c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2Zm8 7.45L4.35 7.7A.5.5 0 0 0 4 8.17V17h16V8.17a.5.5 0 0 0-.35-.47L12 12.45Zm0-2.34L18.1 7H5.9L12 10.11Z" />
            </svg>
        );
    }

    if (icon === "shipping") {
        return (
            <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M3 5h12c.55 0 1 .45 1 1v3h2.65c.36 0 .7.2.88.51l2.34 4.09c.09.15.13.32.13.5V18c0 .55-.45 1-1 1h-1.2a3 3 0 0 1-5.6 0H9.8a3 3 0 0 1-5.6 0H3c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1Zm13 6v4h3.72L18 11h-2ZM7 20.2A1.2 1.2 0 1 0 7 17.8a1.2 1.2 0 0 0 0 2.4Zm10 0a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4ZM4 7v10h.2a3 3 0 0 1 5.6 0H14V7H4Z" />
            </svg>
        );
    }

    return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M3 21V9.6l5 3V8l5 3V7l8 4.8V21H3Zm2-2h14v-6.07l-4-2.4V14.6l-5-3V15.6l-5-3V19Zm2-2h3v-2H7v2Zm5 0h3v-2h-3v2Zm5 0h1v-2h-1v2ZM5 4h4v5.15L5 6.75V4Z" />
        </svg>
    );
}

function getSlidesPerView(width: number, height: number) {
    const isLandscapeMobile = width > height && width <= 920;

    if (isLandscapeMobile) return 3;
    if (width <= 780) return 1;
    if (width <= 1100) return 3;

    return 3;
}

function preloadImages(imageUrls: string[]) {
    return Promise.all(
        imageUrls.map(
            (src) =>
                new Promise<void>((resolve) => {
                    const img = new Image();
                    img.src = src;

                    if (img.complete) {
                        resolve();
                        return;
                    }

                    img.onload = () => resolve();
                    img.onerror = () => resolve();
                })
        )
    );
}

export default function BuzonDelivery() {
    const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);
    const [imagesReady, setImagesReady] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const { spinner } = useContext(SpinnerContext);

    const [slidesPerView, setSlidesPerView] = useState(() => {
        if (typeof window === "undefined") return 3;
        return getSlidesPerView(window.innerWidth, window.innerHeight);
    });

    const heroImage = useMemo(() => baseImages[0], []);
    const clonesCount = slidesPerView;

    const extendedGallery = useMemo(() => {
        if (gallery.length === 0) return [];

        const headClones = gallery.slice(-clonesCount);
        const tailClones = gallery.slice(0, clonesCount);

        return [...headClones, ...gallery, ...tailClones];
    }, [clonesCount]);

    const extendedLightboxGallery = useMemo(() => {
        if (gallery.length === 0) return [];

        return [gallery[gallery.length - 1], ...gallery, gallery[0]];
    }, []);

    const [galleryIndex, setGalleryIndex] = useState(clonesCount);
    const [isAnimating, setIsAnimating] = useState(false);
    const [isAutoPlaying, setIsAutoPlaying] = useState(true);

    const autoplayRef = useRef<number | null>(null);
    const gallerySliderRef = useRef<HTMLDivElement | null>(null);

    const galleryStartXRef = useRef(0);
    const galleryStartYRef = useRef(0);
    const galleryCurrentXRef = useRef(0);
    const galleryCurrentYRef = useRef(0);
    const galleryPointerIdRef = useRef<number | null>(null);
    const galleryTapIndexRef = useRef<number | null>(null);
    const galleryDragStartedRef = useRef(false);
    const galleryClickBlockedRef = useRef(false);
    const galleryTapOpenedRef = useRef(false);

    const lightboxStartXRef = useRef(0);
    const lightboxStartYRef = useRef(0);
    const lightboxCurrentXRef = useRef(0);
    const lightboxCurrentYRef = useRef(0);
    const lightboxPointerIdRef = useRef<number | null>(null);
    const lightboxSliderRef = useRef<HTMLDivElement | null>(null);

    const [galleryWidth, setGalleryWidth] = useState(0);
    const [galleryDragOffset, setGalleryDragOffset] = useState(0);
    const [isGalleryDragging, setIsGalleryDragging] = useState(false);

    const [lightboxDragOffset, setLightboxDragOffset] = useState(0);
    const [isLightboxDragging, setIsLightboxDragging] = useState(false);
    const [lightboxTrackIndex, setLightboxTrackIndex] = useState(1);
    const [lightboxWidth, setLightboxWidth] = useState(0);
    const [isLightboxAnimating, setIsLightboxAnimating] = useState(false);

    const clearAutoplay = () => {
        if (autoplayRef.current !== null) {
            window.clearInterval(autoplayRef.current);
            autoplayRef.current = null;
        }
    };

    const getLightboxRealIndex = (trackIndex: number) => {
        const realIndex = trackIndex - 1;

        return ((realIndex % gallery.length) + gallery.length) % gallery.length;
    };

    const openLightbox = (index: number) => {
        setLightboxIndex(index);
        setLightboxTrackIndex(index + 1);
        setLightboxDragOffset(0);
        setIsLightboxDragging(false);
        setIsLightboxAnimating(false);
    };

    const closeLightbox = () => {
        setLightboxIndex(null);
        setLightboxTrackIndex(1);
        setLightboxDragOffset(0);
        setIsLightboxDragging(false);
        setIsLightboxAnimating(false);
        lightboxPointerIdRef.current = null;
    };

    const moveLightbox = (direction: 1 | -1) => {
        if (lightboxIndex === null) return;
        if (isLightboxAnimating || isLightboxDragging) return;

        const nextTrackIndex = lightboxTrackIndex + direction;

        setLightboxIndex(getLightboxRealIndex(nextTrackIndex));
        setLightboxTrackIndex(nextTrackIndex);
        setLightboxDragOffset(0);
        setIsLightboxAnimating(true);
    };

    const nextLightboxImage = () => {
        moveLightbox(1);
    };

    const prevLightboxImage = () => {
        moveLightbox(-1);
    };

    const handleLightboxTransitionEnd = () => {
        if (lightboxTrackIndex === gallery.length + 1) {
            setIsLightboxAnimating(false);
            setLightboxTrackIndex(1);
            setLightboxIndex(0);
            return;
        }

        if (lightboxTrackIndex === 0) {
            setIsLightboxAnimating(false);
            setLightboxTrackIndex(gallery.length);
            setLightboxIndex(gallery.length - 1);
            return;
        }

        setIsLightboxAnimating(false);
    };

    const nextGallery = () => {
        if (!imagesReady || isAnimating || isGalleryDragging) return;

        setGalleryIndex((prev) => prev + 1);
        setIsAnimating(true);
    };

    const prevGallery = () => {
        if (!imagesReady || isAnimating || isGalleryDragging) return;

        setGalleryIndex((prev) => prev - 1);
        setIsAnimating(true);
    };

    const goToGalleryIndex = (index: number) => {
        if (!imagesReady || isAnimating || isGalleryDragging) return;

        setGalleryIndex(index + clonesCount);
        setIsAnimating(true);
    };

    const handleGalleryTransitionEnd = () => {
        const firstRealIndex = clonesCount;
        const lastRealIndex = gallery.length + clonesCount - 1;

        if (galleryIndex > lastRealIndex) {
            setIsAnimating(false);
            setGalleryIndex(firstRealIndex);
            return;
        }

        if (galleryIndex < firstRealIndex) {
            setIsAnimating(false);
            setGalleryIndex(gallery.length + clonesCount - 1);
            return;
        }

        setIsAnimating(false);
    };

    const handleGalleryPointerDown = (event: React.PointerEvent<HTMLDivElement>) => {
        if (!imagesReady || isAnimating) return;
        if (event.pointerType === "mouse" && event.button !== 0) return;

        const slideElement = (event.target as HTMLElement).closest<HTMLButtonElement>(
            ".buzon6-gallery-slide"
        );

        const tapIndex = slideElement?.dataset.galleryIndex
            ? Number(slideElement.dataset.galleryIndex)
            : null;

        clearAutoplay();

        galleryStartXRef.current = event.clientX;
        galleryStartYRef.current = event.clientY;
        galleryCurrentXRef.current = event.clientX;
        galleryCurrentYRef.current = event.clientY;
        galleryPointerIdRef.current = event.pointerId;
        galleryTapIndexRef.current = tapIndex;
        galleryDragStartedRef.current = false;
        galleryClickBlockedRef.current = false;

        setIsAutoPlaying(false);
        setGalleryDragOffset(0);
    };

    const handleGalleryPointerMove = (event: React.PointerEvent<HTMLDivElement>) => {
        if (galleryPointerIdRef.current !== event.pointerId) return;

        galleryCurrentXRef.current = event.clientX;
        galleryCurrentYRef.current = event.clientY;

        const deltaX = event.clientX - galleryStartXRef.current;
        const deltaY = event.clientY - galleryStartYRef.current;
        const absX = Math.abs(deltaX);
        const absY = Math.abs(deltaY);

        if (!galleryDragStartedRef.current) {
            if (absX < 8 && absY < 8) return;

            if (absY > absX) {
                return;
            }

            galleryDragStartedRef.current = true;
            galleryClickBlockedRef.current = true;

            setIsGalleryDragging(true);
            setIsAnimating(false);

            try {
                event.currentTarget.setPointerCapture(event.pointerId);
            } catch {
                // Algunos navegadores móviles pueden liberar el pointer automáticamente.
            }
        }

        event.preventDefault();
        setGalleryDragOffset(deltaX);
    };

    const finishGalleryDrag = (event: React.PointerEvent<HTMLDivElement>) => {
        if (galleryPointerIdRef.current !== event.pointerId) return;

        const deltaX = galleryCurrentXRef.current - galleryStartXRef.current;
        const deltaY = galleryCurrentYRef.current - galleryStartYRef.current;
        const absX = Math.abs(deltaX);
        const absY = Math.abs(deltaY);

        const wasDragging = galleryDragStartedRef.current;
        const tapIndex = galleryTapIndexRef.current;

        galleryPointerIdRef.current = null;
        galleryTapIndexRef.current = null;
        galleryDragStartedRef.current = false;

        if (!wasDragging) {
            if (absX < 8 && absY < 8 && tapIndex !== null) {
                galleryTapOpenedRef.current = true;
                openLightbox(tapIndex);

                window.setTimeout(() => {
                    galleryTapOpenedRef.current = false;
                }, 450);
            }

            window.setTimeout(() => {
                setIsAutoPlaying(true);
            }, 900);

            return;
        }

        const slideWidth = galleryWidth / slidesPerView;
        const threshold = Math.min(90, Math.max(42, slideWidth * 0.22));

        setIsGalleryDragging(false);
        setGalleryDragOffset(0);

        if (absX > threshold) {
            setGalleryIndex((prev) => (deltaX < 0 ? prev + 1 : prev - 1));
            setIsAnimating(true);
        } else {
            setIsAnimating(true);
        }

        window.setTimeout(() => {
            galleryClickBlockedRef.current = false;
            setIsAutoPlaying(true);
        }, 900);

        try {
            event.currentTarget.releasePointerCapture(event.pointerId);
        } catch {
            // El pointer puede haberse liberado solo en algunos navegadores.
        }
    };

    const cancelGalleryDrag = () => {
        galleryPointerIdRef.current = null;
        galleryTapIndexRef.current = null;
        galleryDragStartedRef.current = false;
        galleryClickBlockedRef.current = false;

        setIsGalleryDragging(false);
        setGalleryDragOffset(0);
        setIsAnimating(true);

        window.setTimeout(() => {
            setIsAutoPlaying(true);
        }, 900);
    };

    const handleLightboxPointerDown = (event: React.PointerEvent<HTMLDivElement>) => {
        if (lightboxIndex === null) return;
        if (isLightboxAnimating) return;
        if (event.pointerType === "mouse" && event.button !== 0) return;

        event.stopPropagation();

        lightboxPointerIdRef.current = event.pointerId;
        lightboxStartXRef.current = event.clientX;
        lightboxStartYRef.current = event.clientY;
        lightboxCurrentXRef.current = event.clientX;
        lightboxCurrentYRef.current = event.clientY;

        setIsLightboxDragging(true);
        setIsLightboxAnimating(false);
        setLightboxDragOffset(0);

        try {
            event.currentTarget.setPointerCapture(event.pointerId);
        } catch {
            // Algunos navegadores móviles pueden liberar el pointer automáticamente.
        }
    };

    const handleLightboxPointerMove = (event: React.PointerEvent<HTMLDivElement>) => {
        if (lightboxPointerIdRef.current !== event.pointerId) return;

        event.stopPropagation();

        lightboxCurrentXRef.current = event.clientX;
        lightboxCurrentYRef.current = event.clientY;

        const deltaX = event.clientX - lightboxStartXRef.current;
        const deltaY = event.clientY - lightboxStartYRef.current;

        const absX = Math.abs(deltaX);
        const absY = Math.abs(deltaY);

        if (absX > absY && absX > 6) {
            event.preventDefault();
        }

        const limitedDeltaX = Math.max(-220, Math.min(220, deltaX));

        setLightboxDragOffset(limitedDeltaX);
    };

    const finishLightboxDrag = (event: React.PointerEvent<HTMLDivElement>) => {
        if (lightboxPointerIdRef.current !== event.pointerId) return;

        event.stopPropagation();

        const deltaX = lightboxCurrentXRef.current - lightboxStartXRef.current;
        const deltaY = lightboxCurrentYRef.current - lightboxStartYRef.current;

        const absX = Math.abs(deltaX);
        const absY = Math.abs(deltaY);

        lightboxPointerIdRef.current = null;

        const isHorizontalSwipe = absX > absY;
        const threshold = Math.min(120, Math.max(60, lightboxWidth * 0.16));

        setIsLightboxDragging(false);
        setLightboxDragOffset(0);

        if (isHorizontalSwipe && absX > threshold) {
            const direction = deltaX < 0 ? 1 : -1;
            const nextTrackIndex = lightboxTrackIndex + direction;

            setLightboxIndex(getLightboxRealIndex(nextTrackIndex));
            setLightboxTrackIndex(nextTrackIndex);
            setIsLightboxAnimating(true);
        } else {
            setIsLightboxAnimating(true);
        }

        try {
            event.currentTarget.releasePointerCapture(event.pointerId);
        } catch {
            // El pointer puede haberse liberado solo en algunos navegadores.
        }
    };

    const cancelLightboxDrag = () => {
        lightboxPointerIdRef.current = null;

        setIsLightboxDragging(false);
        setLightboxDragOffset(0);
        setIsLightboxAnimating(true);
    };

    useEffect(() => {
        let mounted = true;

        const uniqueImages = Array.from(new Set([...baseImages, ...gallery]));

        preloadImages(uniqueImages).then(() => {
            if (!mounted) return;

            setImagesReady(true);
            setGalleryIndex(clonesCount);
        });

        return () => {
            mounted = false;
        };
    }, [clonesCount]);

    useEffect(() => {
        const updateGalleryWidth = () => {
            if (!gallerySliderRef.current) return;
            setGalleryWidth(gallerySliderRef.current.clientWidth);
        };

        updateGalleryWidth();

        const observer =
            typeof ResizeObserver !== "undefined" && gallerySliderRef.current
                ? new ResizeObserver(updateGalleryWidth)
                : null;

        if (observer && gallerySliderRef.current) {
            observer.observe(gallerySliderRef.current);
        }

        window.addEventListener("resize", updateGalleryWidth);

        return () => {
            observer?.disconnect();
            window.removeEventListener("resize", updateGalleryWidth);
        };
    }, []);

    useEffect(() => {
        if (lightboxIndex === null) return;

        const updateLightboxWidth = () => {
            if (!lightboxSliderRef.current) return;
            setLightboxWidth(lightboxSliderRef.current.clientWidth);
        };

        updateLightboxWidth();

        const observer =
            typeof ResizeObserver !== "undefined" && lightboxSliderRef.current
                ? new ResizeObserver(updateLightboxWidth)
                : null;

        if (observer && lightboxSliderRef.current) {
            observer.observe(lightboxSliderRef.current);
        }

        window.addEventListener("resize", updateLightboxWidth);

        return () => {
            observer?.disconnect();
            window.removeEventListener("resize", updateLightboxWidth);
        };
    }, [lightboxIndex]);

    useEffect(() => {
        const handleResize = () => {
            const nextSlidesPerView = getSlidesPerView(window.innerWidth, window.innerHeight);

            setSlidesPerView((prev) =>
                prev === nextSlidesPerView ? prev : nextSlidesPerView
            );

            if (window.innerWidth > 780) {
                setIsMobileMenuOpen(false);
            }
        };

        window.addEventListener("resize", handleResize);
        window.addEventListener("orientationchange", handleResize);

        handleResize();

        return () => {
            window.removeEventListener("resize", handleResize);
            window.removeEventListener("orientationchange", handleResize);
        };
    }, []);

    useEffect(() => {
        if (!imagesReady) return;

        setIsAnimating(false);
        setGalleryDragOffset(0);
        setGalleryIndex(clonesCount);

        const id = window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => {
                setIsAnimating(false);
            });
        });

        return () => window.cancelAnimationFrame(id);
    }, [clonesCount, imagesReady]);

    useEffect(() => {
        clearAutoplay();

        if (!imagesReady || !isAutoPlaying || isAnimating || isGalleryDragging) return;

        autoplayRef.current = window.setInterval(() => {
            setGalleryIndex((prev) => prev + 1);
            setIsAnimating(true);
        }, 3200);

        return () => clearAutoplay();
    }, [imagesReady, isAutoPlaying, isAnimating, isGalleryDragging]);

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (lightboxIndex !== null) {
                if (event.key === "Escape") {
                    closeLightbox();
                }

                if (event.key === "ArrowRight") {
                    nextLightboxImage();
                }

                if (event.key === "ArrowLeft") {
                    prevLightboxImage();
                }
            } else if (event.key === "Escape") {
                setIsMobileMenuOpen(false);
            }
        };

        window.addEventListener("keydown", handleKeyDown);

        return () => window.removeEventListener("keydown", handleKeyDown);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        lightboxIndex,
        lightboxTrackIndex,
        isLightboxAnimating,
        isLightboxDragging,
    ]);

    const currentDotIndex =
        ((galleryIndex - clonesCount) % gallery.length + gallery.length) % gallery.length;

    const slideWidthPercent = 100 / slidesPerView;
    const slideWidthPx = galleryWidth / slidesPerView;
    const translatePx = -(galleryIndex * slideWidthPx) + galleryDragOffset;

    const lightboxTranslatePx =
        -(lightboxTrackIndex * lightboxWidth) + lightboxDragOffset;

    const closeMobileMenu = () => {
        setIsMobileMenuOpen(false);
    };

    return (
        <>
            {spinner}
            <div className="buzon6">
                {!imagesReady && (
                    <div className="buzon6-initial-loader" aria-label="Cargando imágenes">
                        <div className="buzon6-initial-loader-spinner" />
                        <span>Cargando imágenes...</span>
                    </div>
                )}

                <div className="buzon6-topbar">
                    <div className="buzon6-container buzon6-topbar-inner">
                        <span>Recibí sin abrir la puerta</span>
                        <span>Hierro de 3,2 mm</span>
                        <span>Colores personalizados</span>
                    </div>
                </div>

                <header className="buzon6-header">
                    <div className="buzon6-container buzon6-header-inner">
                        <a href="#inicio" className="buzon6-logo" onClick={closeMobileMenu}>
                            <span className="buzon6-logo-mark" />
                            <span className="buzon6-logo-text">BUZON DELIVERY</span>
                        </a>

                        <nav className="buzon6-nav">
                            <a href="#inicio">Inicio</a>
                            <a href="#overview">Beneficios</a>
                            <a href="#specs">Características</a>
                            <a href="#gallery">Galería</a>
                            <a href="#contacto">Presupuesto</a>
                        </nav>

                        <div className="buzon6-header-actions">
                            <a href="#contacto" className="buzon6-header-link">
                                Pedir presupuesto
                            </a>

                            <button
                                type="button"
                                className={`buzon6-mobile-toggle ${isMobileMenuOpen ? "is-open" : ""
                                    }`}
                                onClick={() => setIsMobileMenuOpen((prev) => !prev)}
                                aria-label="Abrir menú"
                                aria-expanded={isMobileMenuOpen}
                            >
                                <span />
                                <span />
                                <span />
                            </button>
                        </div>
                    </div>

                    <div className={`buzon6-mobile-menu ${isMobileMenuOpen ? "is-open" : ""}`}>
                        <a href="#inicio" onClick={closeMobileMenu}>
                            Inicio
                        </a>
                        <a href="#overview" onClick={closeMobileMenu}>
                            Beneficios
                        </a>
                        <a href="#specs" onClick={closeMobileMenu}>
                            Características
                        </a>
                        <a href="#gallery" onClick={closeMobileMenu}>
                            Galería
                        </a>
                        <a href="#contacto" onClick={closeMobileMenu}>
                            Presupuesto
                        </a>
                        <a
                            href="#contacto"
                            className="buzon6-mobile-menu-cta"
                            onClick={closeMobileMenu}
                        >
                            Quiero el mío
                        </a>
                    </div>
                </header>

                <main>
                    <section className="buzon6-hero" id="inicio">
                        <div className="buzon6-container buzon6-hero-inner">
                            <div className="buzon6-hero-copy">
                                <p className="buzon6-kicker">La evolución del buzón tradicional</p>

                                <h1 className="buzon6-hero-title">
                                    BUZON
                                    <br />
                                    DELIVERY
                                </h1>

                                <p className="buzon6-hero-text">
                                    Recibí delivery, paquetes, y correspondencia sin abrir la puerta de tu casa.
                                    Un buzón robusto, moderno y elegante, fabricado con hierro de 3,2 mm de espesor, sin partes
                                    plásticas y con pintura anticorrosiva premium.
                                </p>

                                <div className="buzon6-hero-actions">
                                    <a href="#contacto" className="buzon6-btn buzon6-btn-primary">
                                        Quiero pedir el mío
                                    </a>
                                    <a href="#specs" className="buzon6-btn buzon6-btn-outline">
                                        Ver características
                                    </a>
                                </div>

                                <div className="buzon6-hero-meta">
                                    <div>
                                        <strong>Más seguridad</strong>
                                        <span>Recibís sin abrir la puerta</span>
                                    </div>
                                    <div>
                                        <strong>Doble función</strong>
                                        <span>Delivery, paquetes y cartas</span>
                                    </div>
                                    <div>
                                        <strong>Hecho para durar</strong>
                                        <span>Fabricado con chapa de hierro de 3,2 mm</span>
                                    </div>
                                </div>
                            </div>

                            <div className="buzon6-hero-visual">
                                <span className="buzon6-hero-bg-word">DELIVERY</span>

                                <div className="buzon6-hero-image-wrap">
                                    <img
                                        src={heroImage}
                                        alt="Buzón delivery de frente"
                                        className="buzon6-hero-image"
                                        draggable={false}
                                    />
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="buzon6-overview" id="overview">
                        <div className="buzon6-overview-copy">
                            <div className="buzon6-section-head">
                                <h2>Recibí entregas con más tranquilidad</h2>
                                <span />
                            </div>

                            <p>
                                El Buzón Delivery está pensado para resolver una situación cotidiana:
                                recibir un pedido sin tener que abrir la puerta principal, sin improvisar
                                y sin perder seguridad.
                            </p>

                            <p>
                                Su diseño permite el paso de paquetes, comida, documentación y
                                correspondencia, manteniendo una estética moderna que acompaña la fachada
                                de la casa, comercio u oficina.
                            </p>

                            <a
                                href="#contacto"
                                className="buzon6-btn buzon6-btn-primary buzon6-btn-small"
                            >
                                Consultar precio
                            </a>
                        </div>

                        <div className="buzon6-overview-media">
                            <img
                                src={baseImages[1]}
                                alt="Pedido pasando por el buzón delivery"
                                draggable={false}
                            />
                        </div>
                    </section>

                    <section className="buzon6-tech" id="specs">
                        <div className="buzon6-container">
                            <div className="buzon6-section-head buzon6-section-head-center buzon6-section-head-light">
                                <h2>Características principales</h2>
                                <span />
                            </div>

                            <div className="buzon6-tech-stage">
                                <img
                                    src={baseImages[2]}
                                    alt="Buzón delivery recibiendo correspondencia"
                                    className="buzon6-tech-product"
                                    draggable={false}
                                />

                                <div className="buzon6-tech-point buzon6-tech-point-left-top">
                                    <div className="buzon6-tech-line" />
                                    <div className="buzon6-tech-dot" />
                                    <div className="buzon6-tech-box">
                                        <strong>Hierro de 3,2 mm</strong>
                                        <p>Construcción sólida, resistente y preparada para el uso diario.</p>
                                    </div>
                                </div>

                                <div className="buzon6-tech-point buzon6-tech-point-right-top">
                                    <div className="buzon6-tech-line" />
                                    <div className="buzon6-tech-dot" />
                                    <div className="buzon6-tech-box">
                                        <strong>Sin partes plásticas</strong>
                                        <p>Mayor durabilidad, mejor presencia y terminación más robusta.</p>
                                    </div>
                                </div>

                                <div className="buzon6-tech-point buzon6-tech-point-right-bottom">
                                    <div className="buzon6-tech-line" />
                                    <div className="buzon6-tech-dot" />
                                    <div className="buzon6-tech-box">
                                        <strong>Pintura anticorrosiva premium</strong>
                                        <p>Terminación con doble capa de pintura de alta calidad.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="buzon6-spec-grid">
                                {specs.map((item) => (
                                    <div key={item.label} className="buzon6-spec-card">
                                        <span>{item.label}</span>
                                        <strong>{item.value}</strong>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </section>

                    <section className="buzon6-product">
                        <div className="buzon6-container buzon6-product-inner">
                            <div className="buzon6-product-media">
                                <img
                                    src={baseImages[3]}
                                    alt="Detalle constructivo del buzón delivery"
                                    draggable={false}
                                />
                                <img
                                    src={baseImages[4]}
                                    alt="Terminación del buzón delivery"
                                    draggable={false}
                                />
                            </div>

                            <div className="buzon6-product-copy">
                                <p className="buzon6-product-kicker">
                                    Para viviendas, comercios y oficinas
                                </p>
                                <h2>Un acceso práctico para entregas diarias</h2>
                                <div className="buzon6-product-price">
                                    Diseño robusto, moderno y personalizable
                                </div>

                                <p className="buzon6-product-text">
                                    Ideal para quienes reciben delivery, compras online, documentación
                                    o correspondencia con frecuencia. Se puede instalar en rejas,
                                    portones, puertas o paredes, y adaptarse visualmente al estilo de
                                    cada acceso.
                                </p>

                                <div className="buzon6-feature-grid">
                                    {features.map((feature) => (
                                        <article key={feature.title} className="buzon6-feature-card">
                                            <h3>{feature.title}</h3>
                                            <p>{feature.text}</p>
                                        </article>
                                    ))}
                                </div>

                                <a href="#contacto" className="buzon6-btn buzon6-btn-primary">
                                    Solicitar cotización
                                </a>
                            </div>
                        </div>
                    </section>

                    <section className="buzon6-gallery" id="gallery">
                        <div className="buzon6-container">
                            <div className="buzon6-gallery-top">
                                <div className="buzon6-section-head">
                                    <h2>Detalles del producto</h2>
                                    <span />
                                </div>

                                <div className="buzon6-gallery-controls">
                                    <button
                                        type="button"
                                        className="buzon6-gallery-arrow"
                                        onClick={prevGallery}
                                        aria-label="Imagen anterior"
                                    >
                                        ←
                                    </button>
                                    <button
                                        type="button"
                                        className="buzon6-gallery-arrow"
                                        onClick={nextGallery}
                                        aria-label="Imagen siguiente"
                                    >
                                        →
                                    </button>
                                </div>
                            </div>

                            <div
                                ref={gallerySliderRef}
                                className={`buzon6-gallery-slider ${isGalleryDragging ? "is-dragging" : ""
                                    }`}
                                onMouseEnter={() => setIsAutoPlaying(false)}
                                onMouseLeave={() => setIsAutoPlaying(true)}
                                onPointerDown={handleGalleryPointerDown}
                                onPointerMove={handleGalleryPointerMove}
                                onPointerUp={finishGalleryDrag}
                                onPointerCancel={cancelGalleryDrag}
                            >
                                <div
                                    className={`buzon6-gallery-track ${isGalleryDragging
                                        ? "is-dragging"
                                        : isAnimating
                                            ? "is-animated"
                                            : "is-static"
                                        }`}
                                    style={{
                                        transform: `translate3d(${translatePx}px, 0, 0)`,
                                    }}
                                    onTransitionEnd={handleGalleryTransitionEnd}
                                >
                                    {extendedGallery.map((image, index) => {
                                        const realIndex =
                                            ((index - clonesCount) % gallery.length + gallery.length) %
                                            gallery.length;

                                        return (
                                            <button
                                                key={`${image}-${index}`}
                                                type="button"
                                                className="buzon6-gallery-slide"
                                                data-gallery-index={realIndex}
                                                style={{
                                                    flex: `0 0 ${slideWidthPercent}%`,
                                                    minWidth: `${slideWidthPercent}%`,
                                                }}
                                                onClick={(event) => {
                                                    if (
                                                        galleryClickBlockedRef.current ||
                                                        galleryTapOpenedRef.current
                                                    ) {
                                                        event.preventDefault();
                                                        event.stopPropagation();
                                                        return;
                                                    }

                                                    openLightbox(realIndex);
                                                }}
                                                aria-label={`Abrir imagen ${realIndex + 1}`}
                                            >
                                                <img
                                                    src={image}
                                                    alt={`Detalle del Buzón Delivery ${realIndex + 1}`}
                                                    draggable={false}
                                                />
                                                <span className="buzon6-gallery-zoom">Ver detalle</span>
                                            </button>
                                        );
                                    })}
                                </div>

                                <div className="buzon6-gallery-floating-controls">
                                    <button
                                        type="button"
                                        className="buzon6-gallery-arrow"
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            prevGallery();
                                        }}
                                        aria-label="Imagen anterior"
                                    >
                                        ←
                                    </button>

                                    <button
                                        type="button"
                                        className="buzon6-gallery-arrow"
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            nextGallery();
                                        }}
                                        aria-label="Imagen siguiente"
                                    >
                                        →
                                    </button>
                                </div>
                            </div>

                            <div className="buzon6-gallery-dots">
                                {gallery.map((_, index) => (
                                    <button
                                        key={index}
                                        type="button"
                                        className={index === currentDotIndex ? "is-active" : ""}
                                        onClick={() => goToGalleryIndex(index)}
                                        aria-label={`Ir a imagen ${index + 1}`}
                                    />
                                ))}
                            </div>
                        </div>
                    </section>

                    <section className="buzon6-related">
                        <div className="buzon6-container buzon6-related-inner">
                            <div className="buzon6-related-copy">
                                <p className="buzon6-kicker">Hecho a medida</p>
                                <h2>Pedí tu <br />Buzón Delivery personalizado</h2>
                                <p>
                                    Consultanos también por otras medidas, colores, tipo de instalación y terminación.
                                    Te orientamos para elegir la mejor opción según tu reja, portón,
                                    puerta o pared.
                                </p>
                                <a href="#contacto" className="buzon6-btn buzon6-btn-primary">
                                    Pedir presupuesto
                                </a>
                            </div>

                            <div className="buzon6-related-media">
                                <img
                                    src={baseImages[0]}
                                    alt="Buzón Delivery instalado"
                                    draggable={false}
                                />
                            </div>
                        </div>
                    </section>
                    <ContactForm />
                </main>

                <footer className="buzon6-footer">
                    <div className="buzon6-container buzon6-footer-inner">
                        <div className="buzon6-footer-brand">
                            <div className="buzon6-logo buzon6-logo-footer">
                                <span className="buzon6-logo-mark" />
                                <span className="buzon6-logo-text">BUZON DELIVERY</span>
                            </div>
                            <p>
                                Buzón metálico para recibir delivery, paquetes y
                                correspondencia sin abrir la puerta.
                            </p>
                        </div>

                        <div className="buzon6-footer-grid">
                            {footerItems.map((item) => {
                                const content = (
                                    <>
                                        <span className="buzon6-footer-icon">
                                            <FooterIcon icon={item.icon} />
                                        </span>

                                        <span className="buzon6-footer-item-copy">
                                            <strong>{item.title}</strong>
                                            <span>{item.text}</span>
                                        </span>
                                    </>
                                );

                                if (item.href) {
                                    return (
                                        <a
                                            key={item.title}
                                            href={item.href}
                                            className="buzon6-footer-item"
                                            target={item.icon === "whatsApp" ? "_blank" : undefined}
                                            rel={item.icon === "whatsApp" ? "noreferrer" : undefined}
                                        >
                                            {content}
                                        </a>
                                    );
                                }

                                return (
                                    <div key={item.title} className="buzon6-footer-item">
                                        {content}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </footer>

                {lightboxIndex !== null && (
                    <div
                        className="buzon6-lightbox"
                        role="dialog"
                        aria-modal="true"
                        aria-label="Galería ampliada"
                        onClick={closeLightbox}
                    >
                        <button
                            type="button"
                            className="buzon6-lightbox-close"
                            onClick={closeLightbox}
                            aria-label="Cerrar"
                        >
                            ×
                        </button>

                        <button
                            type="button"
                            className="buzon6-lightbox-arrow buzon6-lightbox-arrow-left"
                            onClick={(e) => {
                                e.stopPropagation();
                                prevLightboxImage();
                            }}
                            aria-label="Imagen anterior"
                        >
                            ←
                        </button>

                        <div
                            ref={lightboxSliderRef}
                            className={`buzon6-lightbox-slider ${isLightboxDragging ? "is-dragging" : ""
                                }`}
                            onClick={(e) => e.stopPropagation()}
                            onPointerDown={handleLightboxPointerDown}
                            onPointerMove={handleLightboxPointerMove}
                            onPointerUp={finishLightboxDrag}
                            onPointerCancel={cancelLightboxDrag}
                        >
                            <div
                                className={`buzon6-lightbox-track ${isLightboxDragging
                                    ? "is-dragging"
                                    : isLightboxAnimating
                                        ? "is-animated"
                                        : "is-static"
                                    }`}
                                style={{
                                    transform: `translate3d(${lightboxTranslatePx}px, 0, 0)`,
                                }}
                                onTransitionEnd={handleLightboxTransitionEnd}
                            >
                                {extendedLightboxGallery.map((image, index) => {
                                    const realIndex =
                                        ((index - 1) % gallery.length + gallery.length) %
                                        gallery.length;

                                    return (
                                        <div
                                            key={`${image}-${index}`}
                                            className="buzon6-lightbox-slide"
                                        >
                                            <img
                                                src={image}
                                                alt={`Detalle ampliado del Buzón Delivery ${realIndex + 1
                                                    }`}
                                                className="buzon6-lightbox-image"
                                                draggable={false}
                                            />
                                        </div>
                                    );
                                })}
                            </div>
                        </div>

                        <button
                            type="button"
                            className="buzon6-lightbox-arrow buzon6-lightbox-arrow-right"
                            onClick={(e) => {
                                e.stopPropagation();
                                nextLightboxImage();
                            }}
                            aria-label="Imagen siguiente"
                        >
                            →
                        </button>
                    </div>
                )}
            </div>
        </>
    );
}